import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import Cache from '@/helper/Cache.js'
import BzbsLogin from '@/core/Account/service/BzbsLogin.js'
import BzbsDashboard from '@/core/Home/BzbsDashboard.js'
import Account from '@/helper/AccountHelper.js'

export default {
  data() {
    return {
      pageTitle: 'CRM Plus Consumer',
      lbl: null,
      currenttimestamp: new Date().getTime(),
      loginTypeList: [],
    }
  },
  computed: {
    code: {
      get() {
        return this.$store.state.localecode
      },
      set(newValue) {
        this.$store.commit('setLocalecode', newValue)
      },
    },
  },
  watch: {
    code(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getlocalStorage()
      }
    },
  },
  created() {
    this.getlocalStorage()
  },
  methods: {
    arrList(string) {
      var list = string.split(',')
      this.loginTypeList = list
      return list
    },
    getlocalStorage() {
      var locale = Cache.get('BzbsLocale')
      this.$store.commit('setLocalecode', locale)
      if (localStorage.getItem('setJsonLocal_' + locale)) {
        this.lbl = JSON.parse(localStorage.getItem('setJsonLocal_' + locale))
      }
    },
    setlocalStorage() {
      var locale = Cache.get('BzbsLocale')
      if (localStorage.getItem('setJsonLocal_' + locale)) {
        this.lbl = JSON.parse(localStorage.getItem('setJsonLocal_' + locale))
      }
    },
    checklocalStorage() {
      return new Promise(resolve => {
        if (this.lbl == null) {
          let interval = setInterval(() => {
            if (this.lbl) {
              clearInterval(interval)
              return resolve(true)
            } else {
              this.getlocalStorage()
            }
          }, 1000)
        } else {
          return resolve(true)
        }
      })
    },
    truncate(num, places) {
      return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places)
    },
    errorResponse(objerror, isPopup, router) {
      var error_message = this.lbl.main.something_went_wrong
      var texterror = []
      if (_.has(objerror, 'response.data.error')) {
        if (
          objerror.response.data.error !== null &&
          objerror.response.data.status_code != 999
        ) {
          const h = this.$createElement
          for (var i = 0; i < objerror.response.data.error.length; i++) {
            texterror.push(
              h(
                'p',
                ' ( ID: ' +
                  objerror.response.data.error[i].id +
                  ' ) ' +
                  objerror.response.data.error[i].message,
              ),
            )
          }
          error_message = texterror
        }
      }
      if (typeof objerror === 'string') {
        error_message = objerror
      }
      if (isPopup) {
        this.handleLoading(false)
        if (router) {
          this.$error({
            title: this.lbl.main.pls_try_agian,
            content: error_message,
            centered: true,
            autoFocusButton: null,
            okText: this.lbl.btn.ok,
            onOk: () => {
              this.$router.push(router)
              this.handleLoading(true)
            },
          })
        } else {
          this.$error({
            title: this.lbl.main.pls_try_agian,
            content: error_message,
            centered: true,
            autoFocusButton: null,
            okText: this.lbl.btn.ok,
            onOk: () => {},
          })
        }
      } else {
        this.$message.error(error_message)
      }
      return error_message
    },
    handleLoading(value) {
      this.$store.commit('Loading', value)
    },
    handleFooter(value) {
      this.$store.commit('FooterMenu', value)
    },
    handleLanguage(value) {
      this.$store.commit('Language', value)
    },
    handleLanguageBottom(value) {
      this.$store.commit('LanguagePosition', value)
    },

    handleshowFGF(value) {
      this.$store.commit('showFGF', value)
    },
    // for ant select search option
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    formatDate(timestamp, format = 'DD-MMM-YYYY') {
      return moment.unix(timestamp).format(format)
    },
    formatDateString(dateString, format = 'DD-MMM-YYYY', calHours = null) {
      return moment(dateString).add(calHours, 'hours').format(format)
    },
    formHasError(fieldsError) {
      return Object.keys(fieldsError).some(field => fieldsError[field])
    },
    successResponse(text, router) {
      this.handleLoading(false)
      var texttitle = ''
      if (text) {
        texttitle = text
      } else {
        texttitle = this.lbl.main.success_popup
      }
      this.$success({
        title: texttitle,
        content: '',
        centered: true,
        autoFocusButton: null,
        closable: true,
        onOk: () => {
          if (typeof router !== 'undefined') {
            if (!(typeof router === 'boolean')) {
              this.$router.push(router)
              this.handleLoading(true)
            }
          } else {
            this.$router.go()
            this.handleLoading(true)
          }
        },
      })
    },
    parseInt(value) {
      if (typeof value === 'string') {
        return parseInt(value)
      } else if (typeof value === 'number') {
        return value
      }
    },
    handleAddAppId(route) {
      if (route.query.app_id) {
        Account.setCacheCustom('app_id', route.query.app_id)
        var User = Account.getCacheCustom('BzbsUser_' + route.query.app_id)
        var data = {}
        if (User != null) {
          data = User
        } else {
          data = {}
        }
        data.appId = route.query.app_id
        data.fullPath = route.path + '?app_id=' + route.query.app_id
        if (route.query.channel_id) {
          data.fullPath =
            data.fullPath + '&channel_id=' + route.query.channel_id
        }
        if (route.query.login) {
          data.fullPath = data.fullPath + '&login=' + route.query.login
        }
        if (route.query.version_liff) {
          data.fullPath =
            data.fullPath + '&version_liff=' + route.query.version_liff
        }
        if (route.query.liffId) {
          data.fullPath = data.fullPath + '&liffId=' + route.query.liffId
        }

        Account.setCacheCustom(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
          data,
        )
      }
    },
    addAppIdByLanding(route) {
      if (route.params.appId) {
        Account.setCacheCustom('app_id', route.params.appId)
        var User = Account.getCacheCustom('BzbsUser_' + route.params.appId)
        var data = {}
        if (User != null) {
          data = User
        } else {
          data = {}
        }
        data.appId = route.params.appId
        data.fullPath = route.path

        Account.setCacheCustom(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
          data,
        )
      }
    },
    handleCheckAppId(route) {
      var User = Account.getCacheCustom(
        'BzbsUser_' + Account.getCacheCustom('app_id'),
      )
      var data = {}
      if (User != null) {
        if (
          (User.appId == undefined || User.appId == null) &&
          route.query.app_id == undefined
        ) {
          window.location.href = '/error/404'
        } else if (route.query.app_id) {
          if (route.query.app_id) {
            Account.setCacheCustom('app_id', route.query.app_id)
            if (User != null) {
              data = User
            } else {
              data = {}
            }
            data.appId = route.query.app_id
            Account.setCacheCustom(
              'BzbsUser_' + Account.getCacheCustom('app_id'),
              data,
            )
          } else {
            window.location.href = '/error/404'
          }
        }
      } else {
        if (route.query.app_id) {
          Account.setCacheCustom('app_id', route.query.app_id)
          if (User != null) {
            data = User
          } else {
            data = {}
          }
          data.appId = route.query.app_id
          Account.setCacheCustom(
            'BzbsUser_' + Account.getCacheCustom('app_id'),
            data,
          )
        } else {
          window.location.href = '/error/404'
        }
      }
    },
    handleCheckLogin(route) {
      if (route.query.app_id) {
        Account.setCacheCustom('app_id', route.query.app_id)
        var data = {}
        var User = Account.getCacheCustom('BzbsUser_' + route.query.app_id)
        if (User != null) {
          data = User
        } else {
          data = {}
        }
        data.appId = route.query.app_id
        this.handleInfo(data, route)
      } else {
        this.handleCheckToken(route)
      }
    },
    handleCheckRegister() {
      var setRegister = Account.getCacheCustom(
        'setRegister_' + Account.getCacheCustom('app_id'),
      )
      if (setRegister != null) {
        if (setRegister.registered != true) {
          if (
            setRegister.loginType == 'Email' ||
            setRegister.loginType == 'Facebook'
          ) {
            window.location.href = '/login'
          } else if (setRegister.loginType == 'Device') {
            window.location.href = '/loginOTP'
          } else {
            window.location.href = '/register'
          }
        }
        console.log('setRegister : ', setRegister)
      } else {
        this.checkRegister()
      }
    },
    checkRegister() {
      let loginType = ''
      this.getCustomerStore().then(result => {
        if (!result.UseSingleUserAccount) {
          BzbsLogin.getCustomerStore().then(res => {
            loginType = res.data.loginType
            this.arrList(loginType)
            Account.apiGetProfile().then(data => {
              if (data != null) {
                if (data.strUserId) {
                  let register = {
                    loginType: loginType,
                    registered: true,
                  }
                  Account.setCacheCustom(
                    'setRegister_' + Account.getCacheCustom('app_id'),
                    register,
                  )
                } else {
                  let register = {
                    loginType: loginType,
                    registered: false,
                  }
                  Account.setCacheCustom(
                    'setRegister_' + Account.getCacheCustom('app_id'),
                    register,
                  )
                  if (loginType == 'Email' || loginType == 'Facebook') {
                    window.location.href = '/login'
                  } else if (loginType == 'Device') {
                    window.location.href = '/loginOTP'
                  } else {
                    window.location.href = '/register'
                  }
                }
              }
            })
          })
        } else {
          if (Account.getCacheToken()) {
            let register = {
              loginType: loginType,
              registered: true,
            }
            Account.setCacheCustom(
              'setRegister_' + Account.getCacheCustom('app_id'),
              register,
            )
          } else {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: this.lbl.error.connectionproblem,
            }
          }
        }
      })
    },
    handleInfo(data, route) {
      Account.setCacheCustom('BzbsUser_' + route.query.app_id, data)
      this.handleCheckToken(route)
    },
    handleCheckToken(route) {
      var token = Account.getCacheToken() ? Account.getCacheToken() : null
      if (token != null) {
        if (token == null || token == '' || token == undefined) {
          this.gotoLogin(route)
        } else {
          BzbsLogin.getCustomerStore().then(res => {
            this.arrList(res.data.loginType)
            if (
              this.loginTypeList.includes('Email') ||
              this.loginTypeList.includes('Facebook') ||
              (this.loginTypeList.includes('Device') &&
                this.loginTypeList.includes('Line'))
            ) {
              BzbsLogin.postDeviceResume()
                .then(res => {
                  if (res.status == 200) {
                    token = res.data.token
                    Account.setCacheToken(token)
                  } else {
                    this.gotoLogin(route)
                  }
                })
                .catch(() => {
                  this.gotoLogin(route)
                })
            }
          })
        }
      } else {
        this.gotoLogin(route)
      }
    },
    gotoLogin(route) {
      if (route.name == 'verifyemail') {
        if (route.query.otp && route.query.refcode) {
          window.location.href =
            '/login?returnURL=' +
            route.name +
            '&otp=' +
            route.query.otp +
            '&refcode=' +
            route.query.refcode
        } else {
          window.location.href = '/landing/email?returnURL=' + route.name
        }
      } else {
        window.location.href = '/landing/email?returnURL=' + route.name
      }
    },
    async getTextFromUrl(url) {
      try {
        const response = await axios.get(url)
        const blob = response.data
        return blob
      } catch (error) {
        console.error('Error fetching blob:', error)
        throw error
      }
    },
    checkPdpaVersion(data, path) {
      return new Promise(resolve => {
        var showTerms = data.last_terms > data.currect_terms
        var showPrivacy = data.last_privacy > data.currect_privacy
        var chkConsent = showTerms || showPrivacy

        if (chkConsent) {
          if (path) {
            return (window.location.href =
              window.location.origin +
              '/pdpa?showPrivacy=' +
              showPrivacy +
              '&showTerms=' +
              showTerms +
              '&redirectUri=' +
              encodeURI(path))
          } else {
            return (window.location.href =
              window.location.origin +
              '/pdpa?showPrivacy=' +
              showPrivacy +
              '&showTerms=' +
              showTerms)
          }
        } else {
          return resolve(true)
        }
      })
    },
    compareCurrentDate(date) {
      if (date) {
        let format = moment(date).format('DD-MM-YYYY')
        let format_now = moment(new Date()).format('DD-MM-YYYY')
        if (format == format_now) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getCustomerStore() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore().then(res => {
          if (
            res.data.loginType == 'Email' ||
            res.data.loginType == 'Facebook'
          ) {
            BzbsLogin.postDeviceResume()
              .then(res => {
                resolve(res.data)
              })
              .catch(error => {
                if (_.isEmpty(error.response)) {
                  this.handleLoading(false)
                  this.showError = true
                  this.dataError = {
                    title: this.lbl.error.errortitle,
                    detail: this.lbl.error.connectionproblem,
                  }
                }
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail:
                    error.response.data.error.message ||
                    this.lbl.error.connectionproblem,
                }
                this.handleLoading(false)
                resolve(error)
              })
          }
        })
      })
    },
    getLevelList(levelSumary) {
      let result = []
      let currentValue = 1 // เริ่มจาก 1 ซึ่งคือ 2^0

      while (currentValue <= levelSumary) {
        if ((levelSumary & currentValue) === currentValue) {
          result.push(currentValue)
        }
        currentValue *= 2 // คูณ 2 เพื่อไปยังค่าในอนุกรมถัดไป
      }
      return result
    },
  },
}
